import {useState} from 'react';
import {InputNumber, Modal} from 'antd';

export const MoneyEntryWidget = ({item, title, value, placeholder, onPriceChange, max, props}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [priceVal, setPriceVal] = useState(parseFloat(value));

    const onClick = () => {
        setIsModalOpen(true);
    }

    const onModalCancel = () => {
        setIsModalOpen(false);
    }

    const onModalOk = () => {
        if (onPriceChange) {
            onPriceChange(priceVal);
        }
        setIsModalOpen(false);
    }

    const onPriceValChange = (val) => {
        setPriceVal(val);
    }

    if (placeholder === undefined) {
        placeholder = "price";
    }

    const defaultValue = (priceVal) ? priceVal.toFixed(2) : `0.00`
    return <div>
        <div onClick={onClick} style={{cursor: 'pointer', color:"#108ee9", margin: "5px"}}>{`$ ${defaultValue}`}</div>
        <Modal open={isModalOpen} onCancel={onModalCancel} onOk={onModalOk}>
            <b>{title}</b><p/>
            <InputNumber style={{width: 200}} placeholder={placeholder} addonBefore={"$"} onChange={onPriceValChange} precision={2} min={0} value={priceVal} max={max} />
        </Modal>
    </div>
}